// Structured data (JSON-LD) per language. Injected via useLocalizedSEO.
// Used on the Landing page to give Google rich SaaS + FAQ snippets.

const SITE = "https://qrmenu-pro.com";

const SOFTWARE = {
  de: {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "qrmenu-pro.com",
    description:
      "Digitale QR-Speisekarte für Restaurants, Cafés und Bars. Mehrsprachig (DE/EN/TR), Live Tisch-Service, GDPR-konform.",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    inLanguage: ["de", "en", "tr"],
    url: `${SITE}/de`,
    offers: [
      { "@type": "Offer", name: "Starter", price: "20", priceCurrency: "EUR" },
      { "@type": "Offer", name: "Pro", price: "40", priceCurrency: "EUR" },
    ],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      reviewCount: "147",
    },
  },
  en: {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "qrmenu-pro.com",
    description:
      "Digital QR menu for restaurants, cafés and bars. Multilingual (DE/EN/TR), live waiter service, GDPR-compliant.",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    inLanguage: ["en", "de", "tr"],
    url: `${SITE}/en`,
    offers: [
      { "@type": "Offer", name: "Starter", price: "20", priceCurrency: "EUR" },
      { "@type": "Offer", name: "Pro", price: "40", priceCurrency: "EUR" },
    ],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      reviewCount: "147",
    },
  },
  tr: {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "qrmenu-pro.com",
    description:
      "Restoranlar, kafeler ve barlar için dijital QR menü. Çok dilli (DE/EN/TR), canlı garson çağırma, KVKK/GDPR uyumlu.",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    inLanguage: ["tr", "de", "en"],
    url: `${SITE}/tr`,
    offers: [
      { "@type": "Offer", name: "Starter", price: "20", priceCurrency: "EUR" },
      { "@type": "Offer", name: "Pro", price: "40", priceCurrency: "EUR" },
    ],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      reviewCount: "147",
    },
  },
};

const FAQ_BY_LANG = {
  de: [
    {
      q: "Was ist eine digitale QR-Speisekarte?",
      a: "Eine digitale QR-Speisekarte ist eine moderne, mobile Restaurant-Menükarte, die deine Gäste mit ihrem Smartphone per QR-Code aufrufen. Sie ersetzt klassische Papier-Karten, ist sofort aktualisierbar und mehrsprachig.",
    },
    {
      q: "Wie lange dauert die Einrichtung?",
      a: "In der Regel weniger als 10 Minuten. Du erstellst ein Konto, lädst dein Menü hoch, generierst deinen QR-Code und druckst ihn aus.",
    },
    {
      q: "Funktioniert das auch mehrsprachig?",
      a: "Ja. qrmenu-pro.com unterstützt Deutsch, Englisch und Türkisch — deine Gäste sehen dein Menü automatisch in ihrer Sprache.",
    },
    {
      q: "Gibt es eine kostenlose Testphase?",
      a: "Ja. Du startest mit einer 15-tägigen kostenlosen Testphase — ohne Kreditkarte.",
    },
  ],
  en: [
    {
      q: "What is a digital QR menu?",
      a: "A digital QR menu is a modern, mobile restaurant menu your guests open via QR code with their smartphone. It replaces paper menus, can be updated instantly, and is fully multilingual.",
    },
    {
      q: "How long does setup take?",
      a: "Typically less than 10 minutes. You create an account, upload your menu, generate your QR code, and print it.",
    },
    {
      q: "Does it support multiple languages?",
      a: "Yes. qrmenu-pro.com supports German, English and Turkish — your guests automatically see the menu in their language.",
    },
    {
      q: "Is there a free trial?",
      a: "Yes. You start with a 15-day free trial — no credit card required.",
    },
  ],
  tr: [
    {
      q: "Dijital QR menü nedir?",
      a: "Dijital QR menü, müşterilerinizin akıllı telefonlarıyla QR kod üzerinden açtığı modern, mobil bir restoran menüsüdür. Kâğıt menüleri tamamen değiştirir, anında güncellenebilir ve çok dillidir.",
    },
    {
      q: "Kurulum ne kadar sürer?",
      a: "Genellikle 10 dakikadan az. Hesap oluşturursunuz, menünüzü yüklersiniz, QR kodunuzu üretip yazdırırsınız.",
    },
    {
      q: "Çok dilli menü destekliyor mu?",
      a: "Evet. qrmenu-pro.com Almanca, İngilizce ve Türkçe destekler — misafirleriniz menünüzü otomatik olarak kendi dillerinde görür.",
    },
    {
      q: "Ücretsiz deneme var mı?",
      a: "Evet. 15 günlük ücretsiz deneme ile başlarsınız — kredi kartı gerekmez.",
    },
  ],
};

function faqJsonLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };
}

export const LANDING_JSON_LD = {
  de: [SOFTWARE.de, faqJsonLd(FAQ_BY_LANG.de)],
  en: [SOFTWARE.en, faqJsonLd(FAQ_BY_LANG.en)],
  tr: [SOFTWARE.tr, faqJsonLd(FAQ_BY_LANG.tr)],
};

export const FAQ_ITEMS_BY_LANG = FAQ_BY_LANG;
